/**
 * The header's monitor trace: twelve beats across a 1440 × 16 box. Shared by
 * components/layout/PulseTrace.tsx and the static twin in
 * scripts/prerender-markup.mjs.
 */
export const PULSE_PATH = Array.from({ length: 12 }, (_, i) => {
  const x = i * 120;
  return `M${x} 8 H${x + 52} L${x + 58} 3 L${x + 64} 13 L${x + 70} 1 L${x + 76} 10 L${x + 80} 8 H${x + 120}`;
}).join(" ");
